import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { AppointmentDetailsController } from "@/components/calendar/useAppointmentDetailsController";

export function AppointmentStatusCard({ ctrl }: { ctrl: AppointmentDetailsController }) {
  const { t } = useTranslation("calendar");
  const { sidePanelStatuses, sidePanelValue, handleStatusChange } = ctrl;
  return (
    <section className="rounded-[18px] border border-border/30 bg-card p-4 shadow-sm">
      <div className="mb-2.5 text-sm font-bold">{t("appointmentDetails.statusTitle")}</div>
      <Select value={sidePanelValue} onValueChange={handleStatusChange}>
        <SelectTrigger className="h-auto rounded-xl bg-background-app px-3.5 py-2.5">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {sidePanelStatuses.map((s) => (
            <SelectItem key={s.name} value={s.name}>
              {s.display_name ?? s.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </section>
  );
}
